export default __webpack_public_path__ + "static/media/leftarrows.e268b487.svg";